import * as Yup from 'yup';

const schema = Yup.object()
  .shape({
    username: Yup.string()
      .required('Nome não pode estar vazio')
      .matches(
        /^[a-zA-Z0-9áéíóúâêîôûàèìòùãõçÁÉÍÓÚÂÊÎÔÛÀÈÌÒÙÃÕÇ\s-]+$/,
        'O nome deve conter apenas letras e números',
      )
      .max(100, 'O nome pode ter até 100 caracteres'),
    email: Yup.string()
      .required('E-mail de usuário obrigatório')
      .email('E-mail inválido'),
  })
  .required();

export type formSchemaType = Yup.InferType<typeof schema>;

export default schema;
